import React from 'react';
import { Button as MuiButton } from '@mui/material';
import { BRAND_COLORS } from '../../constants/taskStatuses';

/**
 * Shared Button component mirroring Figma predefined styles.
 * 
 * @param {Object} props
 * @param {"primary" | "secondary"} [props.variant="primary"] - Button style variant
 * @param {string} [props.width] - Optional hardcoded width
 * @param {string} [props.height="40px"] - Default height per Figma
 */
const Button = ({
    variant = "primary",
    width,
    height = "40px",
    sx = {},
    children,
    ...props
}) => {
    // Shared styling for both variants
    const baseSx = {
        textTransform: 'none',
        borderRadius: "8px", // "Radius Large"
        gap: "4px",
        height: height,
        px: 3, // mapped Margin/xl roughly
        py: 1, // mapped Margin/md roughly
        fontWeight: 500,
        boxShadow: "none",
        whiteSpace: 'nowrap',
        minWidth: 'fit-content',
        ...(width && { width })
    };

    // Primary style (e.g. Manage User)
    const primarySx = {
        backgroundColor: BRAND_COLORS.PRIMARY,
        color: "#FFFFFF",
        "&:hover": {
            backgroundColor: BRAND_COLORS.PRIMARY_HOVER, // Slightly darker for hover
            boxShadow: "none"
        }
    };

    // Secondary style (e.g. Upload)
    const secondarySx = {
        backgroundColor: "transparent",
        color: BRAND_COLORS.PRIMARY,
        border: `1px solid ${BRAND_COLORS.PRIMARY}`,
        "&:hover": {
            backgroundColor: BRAND_COLORS.SECONDARY_HOVER, // Very light blue for hover
            border: `1px solid ${BRAND_COLORS.PRIMARY}`
        }
    };

    return (
        <MuiButton
            variant={variant === "primary" ? "contained" : "outlined"}
            sx={{
                ...baseSx,
                ...(variant === "primary" ? primarySx : secondarySx),
                ...sx
            }}
            {...props}
        >
            {children}
        </MuiButton>
    );
};

export default Button;
